import { backlogFetch } from './performance-analytics.tsx';

export const setBacklogFetchStart = () => {
	backlogFetch.start();
};

export const setBacklogFetchStop = () => {
	backlogFetch.stop();
};
